var version = {
    "name":      "dativery",
    "buildDateCode": "20260429-095818",
    "buildDate": "Wed Apr 29 2026 09:58:18 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260429-095818",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;